/**
 * Generated from TrashCollectLayout.fla
 */
export function TrashCollectLayout(this: ITrashCollectLayout) {
	const main = this.main;
	TrashCollectLayout_main.call(this.main);
	main.x = 512;
	main.y = 384;
	if (main.scale) main.scale.x = 0.500;
	if (main.scale) main.scale.y = 0.500;
	if (main.onLayout) main.onLayout();
	const hud = this.hud;
	TrashCollectLayout_hud.call(this.hud);
	hud.x = 0;
	hud.y = 0;
	if (hud.scale) hud.scale.x = 0.500;
	if (hud.scale) hud.scale.y = 0.500;
	if (hud.onLayout) hud.onLayout();
	return this;
}
export function TrashCollectLayout_main(this: ITrashCollectLayout_main) {
	const bg = this.bg;
	if (!bg[0] && bg.elementFactory) {
		bg[0] = bg.elementFactory(0,undefined);
	}
	if (bg[0]) {
		TrashCollectLayout_parkBackground.call(bg[0] as ITrashCollectLayout_parkBackground);
		bg[0].x = 0;
		bg[0].y = 0;
		bg[0].width = 3328.00;
		bg[0].height = 1535.95;
		if (bg[0].onLayout) bg[0].onLayout();
	}
	if (!bg[1] && bg.elementFactory) {
		bg[1] = bg.elementFactory(1,undefined);
	}
	if (bg[1]) {
		TrashCollectLayout_parkBackground.call(bg[1] as ITrashCollectLayout_parkBackground);
		bg[1].x = 3328;
		bg[1].y = 0;
		bg[1].width = 3328.00;
		bg[1].height = 1535.95;
		if (bg[1].onLayout) bg[1].onLayout();
	}
	if (!bg[2] && bg.elementFactory) {
		bg[2] = bg.elementFactory(2,undefined);
	}
	if (bg[2]) {
		TrashCollectLayout_parkBackground.call(bg[2] as ITrashCollectLayout_parkBackground);
		bg[2].x = 6656;
		bg[2].y = 0;
		bg[2].width = 3328.00;
		bg[2].height = 1535.95;
		if (bg[2].onLayout) bg[2].onLayout();
	}
	const easteregg = this.easteregg;
	if (!easteregg[0] && easteregg.elementFactory) {
		easteregg[0] = easteregg.elementFactory(0,undefined);
	}
	if (easteregg[0]) {
		TrashCollectLayout_bird.call(easteregg[0] as ITrashCollectLayout_bird);
		easteregg[0].x = 524.1;
		easteregg[0].y = 255.3;
		easteregg[0].width = 103.00;
		easteregg[0].height = 103.00;
		if (easteregg[0].onLayout) easteregg[0].onLayout();
	}
	if (!easteregg[1] && easteregg.elementFactory) {
		easteregg[1] = easteregg.elementFactory(1,undefined);
	}
	if (easteregg[1]) {
		TrashCollectLayout_squirrel.call(easteregg[1] as ITrashCollectLayout_squirrel);
		easteregg[1].x = 7271.5;
		easteregg[1].y = -63;
		easteregg[1].width = 164.00;
		easteregg[1].height = 121.00;
		if (easteregg[1].onLayout) easteregg[1].onLayout();
	}
	const spawnPoints = this.spawnPoints;
	if (!spawnPoints[0] && spawnPoints.elementFactory) {
		spawnPoints[0] = spawnPoints.elementFactory(0,undefined);
	}
	if (spawnPoints[0]) {
		TrashCollectLayout_spawnPoints0.call(spawnPoints[0] as ITrashCollectLayout_spawnPoints0);
		spawnPoints[0].x = 373.35;
		spawnPoints[0].y = 491.05;
		spawnPoints[0].width = 38.70;
		spawnPoints[0].height = 40.00;
		if (spawnPoints[0].onLayout) spawnPoints[0].onLayout();
	}
	if (!spawnPoints[1] && spawnPoints.elementFactory) {
		spawnPoints[1] = spawnPoints.elementFactory(1,undefined);
	}
	if (spawnPoints[1]) {
		TrashCollectLayout_spawnPoints0.call(spawnPoints[1] as ITrashCollectLayout_spawnPoints0);
		spawnPoints[1].x = 636.7;
		spawnPoints[1].y = 459.3;
		spawnPoints[1].width = 38.70;
		spawnPoints[1].height = 40.00;
		if (spawnPoints[1].onLayout) spawnPoints[1].onLayout();
	}
	if (!spawnPoints[2] && spawnPoints.elementFactory) {
		spawnPoints[2] = spawnPoints.elementFactory(2,undefined);
	}
	if (spawnPoints[2]) {
		TrashCollectLayout_spawnPoints0.call(spawnPoints[2] as ITrashCollectLayout_spawnPoints0);
		spawnPoints[2].x = 80.6;
		spawnPoints[2].y = 471.3;
		spawnPoints[2].width = 38.70;
		spawnPoints[2].height = 40.00;
		if (spawnPoints[2].onLayout) spawnPoints[2].onLayout();
	}
	if (!spawnPoints[3] && spawnPoints.elementFactory) {
		spawnPoints[3] = spawnPoints.elementFactory(3,undefined);
	}
	if (spawnPoints[3]) {
		TrashCollectLayout_spawnPoints0.call(spawnPoints[3] as ITrashCollectLayout_spawnPoints0);
		spawnPoints[3].x = 905.1;
		spawnPoints[3].y = 499.05;
		spawnPoints[3].width = 38.70;
		spawnPoints[3].height = 40.00;
		if (spawnPoints[3].onLayout) spawnPoints[3].onLayout();
	}
	const bench = this.bench;
	TrashCollectLayout_bench.call(this.bench);
	bench.x = 2993.95;
	bench.y = 221.5;
	bench.width = 734.00;
	bench.height = 443.00;
	if (bench.onLayout) bench.onLayout();
	const lamp = this.lamp;
	TrashCollectLayout_lamp.call(this.lamp);
	lamp.x = 5638.5;
	lamp.y = 427.05;
	lamp.width = 175.00;
	lamp.height = 1046.00;
	if (lamp.onLayout) lamp.onLayout();
	const oscar = this.oscar;
	TrashCollectLayout_oscar.call(this.oscar);
	oscar.x = -616;
	oscar.y = 535.5;
	oscar.width = 850.00;
	oscar.height = 655.15;
	if (oscar.onLayout) oscar.onLayout();
	return this;
}
function TrashCollectLayout_parkBackground(this: ITrashCollectLayout_parkBackground) {
	if (this.setLayoutTexture) this.setLayoutTexture("bg.png", 0.500, 0.500);
	return this;
}
function TrashCollectLayout_bench(this: ITrashCollectLayout_bench) {
	if (this.setLayoutTexture) this.setLayoutTexture("bench.png", 0.500, 0.500);
	return this;
}
function TrashCollectLayout_lamp(this: ITrashCollectLayout_lamp) {
	if (this.setLayoutTexture) this.setLayoutTexture("lamp.png", 0.500, 1.000);
	return this;
}
function TrashCollectLayout_bird(this: ITrashCollectLayout_bird) {
	if (this.setLayoutTexture) this.setLayoutTexture("interaction-bird.png", 0.621, 0.990);
	return this;
}
function TrashCollectLayout_squirrel(this: ITrashCollectLayout_squirrel) {
	if (this.setLayoutTexture) this.setLayoutTexture("interaction-squirrel.png", 0.466, 0.917);
	return this;
}
function TrashCollectLayout_spawnPoints0(this: ITrashCollectLayout_spawnPoints0) {
	return this;
}
function TrashCollectLayout_oscar(this: ITrashCollectLayout_oscar) {
	if (this.setLayoutTexture) this.setLayoutTexture("Trash-Blaster-1.png", 0.360, 1.000);
	return this;
}
export function TrashCollectLayout_hud(this: ITrashCollectLayout_hud) {
	const rightButton = this.rightButton;
	TrashCollectLayout_rightButton.call(this.rightButton);
	rightButton.x = 2048;
	rightButton.y = 785;
	rightButton.width = 165.00;
	rightButton.height = 166.00;
	if (rightButton.onLayout) rightButton.onLayout();
	const leftButton = this.leftButton;
	TrashCollectLayout_leftButton.call(this.leftButton);
	leftButton.x = 0;
	leftButton.y = 785;
	leftButton.width = 165.00;
	leftButton.height = 166.00;
	if (leftButton.onLayout) leftButton.onLayout();
	const homeButton = this.homeButton;
	TrashCollectLayout_homeButton.call(this.homeButton);
	homeButton.x = 216;
	homeButton.y = 329;
	homeButton.width = 292.00;
	homeButton.height = 302.00;
	if (homeButton.onLayout) homeButton.onLayout();
	return this;
}
function TrashCollectLayout_rightButton(this: ITrashCollectLayout_rightButton) {
	if (this.setLayoutTexture) this.setLayoutTexture("next-btn.png", 1.000, 0.500);
	return this;
}
function TrashCollectLayout_leftButton(this: ITrashCollectLayout_leftButton) {
	if (this.setLayoutTexture) this.setLayoutTexture("back-btn.png", 0.000, 0.500);
	return this;
}
function TrashCollectLayout_homeButton(this: ITrashCollectLayout_homeButton) {
	if (this.setLayoutTexture) this.setLayoutTexture("home-btn.png", 0.500, 0.500);
	return this;
}
interface ITrashCollectLayoutArray<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface ITrashCollectLayoutContainer {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface ITrashCollectLayoutSprite extends ITrashCollectLayoutContainer {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
}
interface ITrashCollectLayoutText extends ITrashCollectLayoutContainer {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface ITrashCollectLayoutPolygon extends Array<number> {
}
interface ITrashCollectLayout {
	readonly main: ITrashCollectLayout_main;
	readonly hud: ITrashCollectLayout_hud;
}
interface ITrashCollectLayout_main extends ITrashCollectLayoutContainer {
	readonly bg: ITrashCollectLayoutArray<ITrashCollectLayout_parkBackground>;
	readonly easteregg: ITrashCollectLayoutArray<ITrashCollectLayout_bird|ITrashCollectLayout_squirrel>;
	readonly spawnPoints: ITrashCollectLayoutArray<ITrashCollectLayout_spawnPoints0>;
	readonly bench: ITrashCollectLayout_bench;
	readonly lamp: ITrashCollectLayout_lamp;
	readonly oscar: ITrashCollectLayout_oscar;
}
interface ITrashCollectLayout_parkBackground extends ITrashCollectLayoutSprite {
}
interface ITrashCollectLayout_bench extends ITrashCollectLayoutSprite {
}
interface ITrashCollectLayout_lamp extends ITrashCollectLayoutSprite {
}
interface ITrashCollectLayout_bird extends ITrashCollectLayoutSprite {
}
interface ITrashCollectLayout_squirrel extends ITrashCollectLayoutSprite {
}
interface ITrashCollectLayout_spawnPoints0 extends ITrashCollectLayoutContainer {
}
interface ITrashCollectLayout_oscar extends ITrashCollectLayoutSprite {
}
interface ITrashCollectLayout_hud extends ITrashCollectLayoutContainer {
	readonly rightButton: ITrashCollectLayout_rightButton;
	readonly leftButton: ITrashCollectLayout_leftButton;
	readonly homeButton: ITrashCollectLayout_homeButton;
}
interface ITrashCollectLayout_rightButton extends ITrashCollectLayoutSprite {
}
interface ITrashCollectLayout_leftButton extends ITrashCollectLayoutSprite {
}
interface ITrashCollectLayout_homeButton extends ITrashCollectLayoutSprite {
}
